import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const CountryLife: Site = {
  id: 'countrylife',
  logo: 'svg/countrylife.svg',
  label: 'Country Life',
  analyticsName: 'countrylife',
  hostname: 'countrylife.co.uk',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
